module.exports = __webpack_public_path__ + "static/media/Trollface-PNG-Image.e53c2d69.png";